export default "/b7be2ad489f69f009297c0e1762c95b4.svg";